<script lang="ts">
	import Button from '$lib/components/atoms/button/Button.svelte';
	import { getMapLayoutContext } from '$lib/components/map/map-layout-context';
	import TrafficInfoLayerSwitch from '$lib/components/map/mapTools/switches/TrafficInfoLayerSwitch.svelte';
	import TrafficInfoPageSwitch from '$lib/components/map/mapTools/switches/TrafficInfoPageSwitch.svelte';
	import { track } from '$lib/services/tracking/googleAnalytics';
	import { getSearchParamsStore, gotoWithParams } from '$lib/services/urls/searchParams';
	import * as m from '$paraglide/messages';
	import SettingsCard from './SettingsCard.svelte';

	interface Props {
		isTrafficPage: boolean;
	}

	const { isTrafficPage }: Props = $props();

	const { isTrafficInfoVisible } = getMapLayoutContext();
	const searchParams = getSearchParamsStore();

	function handleClick() {
		track({
			action: 'traffic_info_page',
			payload: {
				action: 'on',
				context: 'modal',
			},
		});
		gotoWithParams('/map/traffic', $searchParams);
	}
</script>

<SettingsCard>
	{#snippet title()}
		<div class="text-sm text-bold">{m.traffic_info_settings__header()}</div>
	{/snippet}
	<div class="flex flex-col p-t-0 p-b-2 p-x-2 items-start gap-4 self-stretch">
		<TrafficInfoLayerSwitch {isTrafficPage} />
		{#if $isTrafficInfoVisible}
			<div class="flex flex-col items-start gap-2">
				<div class="flex self-stretch items-start gap-0.5">
					<div class="w-19 h-1 relative rd-1 bg-traffic-fluid"></div>
					<div class="w-19 h-1 relative rd-1 bg-traffic-dense"></div>
					<div class="w-19 h-1 relative rd-1 bg-traffic-saturated"></div>
					<div class="w-19 h-1 relative rd-1 bg-neutral-strongest"></div>
				</div>
				<div class="flex text-coloredneutral text-sm self-stretch items-start gap-0.5">
					<div class="w-19">{m.map_tools__traffic_info_fluid__label()}</div>
					<div class="w-19">{m.map_tools__traffic_info_busy__label()}</div>
					<div class="w-19">{m.map_tools__traffic_info_heavy__label()}</div>
					<div class="w-19">{m.map_tools__traffic_info_closed_lane__label()}</div>
				</div>
			</div>
			{#if isTrafficPage}
				<TrafficInfoPageSwitch />
			{:else}
				<Button
					color="light"
					icon="east"
					iconPosition="right"
					text={m.map_tools__traffic_info_display_alerts__label()}
					variant="filled"
					onclick={handleClick}
				/>
			{/if}
		{/if}
	</div>
</SettingsCard>
